<button
  [ngClass]="isUploading && progress ? 'mat-progress-button-' + progress! : ''"
  mat-button
  (click)="file.click()"
>
  <ng-container *ngIf="fileData; else empty">
    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <ng-container [ngSwitch]="fileData!.extension">
          <mat-icon svgIcon="file" *ngSwitchCase="extension.Unknown"></mat-icon>
          <mat-icon
            svgIcon="office"
            *ngSwitchCase="extension.Access"
          ></mat-icon>
          <mat-icon
            svgIcon="certificate"
            *ngSwitchCase="extension.Certificate"
          ></mat-icon>
          <mat-icon
            svgIcon="file-excel"
            *ngSwitchCase="extension.Excel"
          ></mat-icon>
          <mat-icon
            svgIcon="file-image"
            *ngSwitchCase="extension.Image"
          ></mat-icon>
          <mat-icon
            svgIcon="folder-key"
            *ngSwitchCase="extension.KeyFile"
          ></mat-icon>
          <mat-icon
            svgIcon="file-music"
            *ngSwitchCase="extension.Music"
          ></mat-icon>
          <mat-icon svgIcon="file-pdf" *ngSwitchCase="extension.Pdf"></mat-icon>
          <mat-icon
            svgIcon="file-powerpoint"
            *ngSwitchCase="extension.Powerpoint"
          ></mat-icon>
          <mat-icon
            svgIcon="note-text"
            *ngSwitchCase="extension.Text"
          ></mat-icon>
          <mat-icon
            svgIcon="file-video"
            *ngSwitchCase="extension.Video"
          ></mat-icon>
          <mat-icon
            svgIcon="file-word"
            *ngSwitchCase="extension.Word"
          ></mat-icon>
          <mat-icon svgIcon="file-xml" *ngSwitchCase="extension.Xml"></mat-icon>
        </ng-container>
        <span>{{ fileData!.title }}</span>
      </div>
      <span class="upload-info"
        ><ng-container i18n>Uploaded: </ng-container>
        {{ fileData!.uploadDate | date: 'short' }}</span
      >
    </div>
  </ng-container>
  <ng-template #empty>
    <span i18n>Choose File</span>
  </ng-template>
</button>
<input
  fxHide
  type="file"
  [accept]="accept"
  #file
  (change)="fileSelect($any($event))"
/>
